import { API_URLS } from "../../config/apiUrls";
import axiosInstance from "../../config/axios";

export const getCodManagementFn = (reqBody) => {
    try {
        const response = axiosInstance.get(API_URLS.codManagement, {
            params: reqBody,
        });
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

export const postCodManagementFn = (reqBody) => {
    try {
        const response = axiosInstance.post(API_URLS.codManagement, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};
export const patchCodManagementFn = (reqBody) => {
    try {
        const response = axiosInstance.patch(API_URLS.codManagement, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

export const DeleteCodManagementFn = (reqBody) => {
    try {
        const response = axiosInstance.delete(API_URLS.codManagement, { data: reqBody });
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

